export const LOADING_SKELETON_TEST_ID = "loading-skeleton";
export const MAXIMUM_TOOLTIP_ITEMS = 30;
